<template>
  <div>
    <IcaConsentDiffModal v-if="useIcaConsentDiffModal" />
  </div>
</template>

<script>

import IcaConsentDiffModal from "~/@ica/ica-molecules-vue/src/components/ConsentDiffModal.vue"

export default {
  name: 'FooterModals',
  components: {
    IcaConsentDiffModal
  },
  props: {
    useIcaConsentDiffModal: {
      type: Boolean,
      default: true
    },
    useIcaConsentSDK: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  mounted () {
    let ICAConsentSDKScript = document.createElement('script')
    ICAConsentSDKScript.setAttribute('src', 'https://assets.icanet.se/raw/upload/v1588160660/spa-application/cookieconsent/ICAConsentSDK-0a615fbcdea30871e84f.js')
    ICAConsentSDKScript.setAttribute('integrity', 'sha256-Al1PnEoE6LjC34bUvd4RaSggkPE9a21VgBC8VWMlnHw= sha384-+XD7UK70xDvHtJ4vm4QJ0tqtaCj7A/Uv5p8k5zpymrFekC3qeovUgdk55+HJ9OYa sha512-UJ0Z1ZtZ57adyIVwC7pk2NgMwP9c1OUH33qRFrRzQuiBr9ZgWs1LJh4FRgGZmRgoIf6uCwEwWYGX5HybIID3EQ=')
    ICAConsentSDKScript.setAttribute('crossorigin', 'anonymous')
    document.body.appendChild(ICAConsentSDKScript)
  }
}
</script>
